/**
* Binds event handlers to modal elements for custom behavior.
*/
function hidePdpModal() {
    var $pdpModal = $("#pdpModal");

    if ($pdpModal.length && ($pdpModal.hasClass("show") || $pdpModal.is(":visible"))) {
        $pdpModal.modal("hide");
    }
}

// Hides any open reservation modals identified by the "reserveModal-" id prefix.
function hideReserveModal() {
    var $reserveModals = $("[id^='reserveModal-']");

    if ($reserveModals.length > 0) {
        $reserveModals.each(function () {
            var $reserveModal = $(this);

            if ($reserveModal.hasClass("show") || $reserveModal.is(":visible")) {
                $reserveModal.modal("hide");
            }
        });
    }
}

function bindEvents() {

    var $body = $("body");
    var $document = $(document);

    $(".modal-secondary").off("show.bs.modal.secondary").on("show.bs.modal.secondary", function () {
        $body.addClass("modal-secondary-open");
    });

    $document.on("hidden.bs.modal", ".modal-secondary", function () {
        if ($(".modal.show").length === 0) {
            $body.removeClass("modal-secondary-open");
        }
    });

    $body.on("product:beforeAddToCart", hidePdpModal);
    window.addEventListener("lce:actions.product_add_to_cart", hidePdpModal);
    window.addEventListener("lce:actions.product_add_to_cart", hideReserveModal);
    window.addEventListener("lce:actions.cart_product_add_success", hidePdpModal);
    window.addEventListener("lce:actions.cart_product_add_success", hideReserveModal);

    $(document)
        .off("shown.bs.modal.retailersTracking", "#retailersModal")
        .on("shown.bs.modal.retailersTracking", "#retailersModal", function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "cta_click",
                ctaName: "Buy Online"
            });
        });
}

export default function () {
    bindEvents();
}
